import flatten from 'flat';
import organizationSettings from './en-US/organizationSettings';
import settings from './en-US/settings';

export default flatten({
  ...organizationSettings,
  ...settings,
});
